import { render, staticRenderFns } from "./df-promotion-card.vue?vue&type=template&id=0766f2f0"
import script from "./df-promotion-card.ts?vue&type=script&lang=js&external"
export * from "./df-promotion-card.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports